<template>
  <div class="location-section">
    <h1 class="location-title">Location</h1>
    <p class="location-description">
      Discover the prime location of Arina East Residences, offering exceptional connectivity and convenience. Situated in a serene city-fringe enclave, this exclusive freehold development is just 3 minutes from Katong Park MRT, with effortless access to the CBD, Marina Bay, and Changi Airport. Surrounded by top schools, lifestyle hubs, and East Coast Park, it’s the perfect place to call home.
    </p>

    <!-- Location Map Image -->
    <v-card class="location-card" elevation="4">
      <v-img
        src="@/assets/4_Location.png"
        aspect-ratio="16/9"
        class="location-map-img"
        cover
      ></v-img>
    </v-card>

    <!-- Find Out More Button -->
    <v-btn
      color="primary"
      class="location-button"
      @click="scrollToSection('enquire')"
    >
      Find Out More
    </v-btn>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LocationView',
  props: {
    scrollToSection: Function, // Accept method as a prop
  },
});
</script>

<style scoped>
.location-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 60px 20px;
  background-color: #F7F4ED;
  border-radius: 12px;
  margin: 20px auto;
  max-width: 800px;
  width: 100%;
}

.location-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 20px;
}

.location-description {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 32px;
  max-width: 700px;
}

/* Location Map Card */
.location-card {
  width: 100%;
  max-width: 600px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;
}

.location-map-img {
  width: 100%;
  height: auto;
}

/* Button Styles */
.location-button {
  font-size: 1rem;
  font-weight: bold;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.location-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

/* Responsive Adjustments */
@media (max-width: 600px) {
  .location-section {
    padding: 30px 10px;
  }

  .location-title {
    font-size: 2rem;
  }

  .location-description {
    font-size: 1rem;
  }

  .location-card {
    max-width: 100%;
  }

  .location-button {
    font-size: 0.9rem;
    padding: 10px 20px;
    width: 100%;
  }
}
</style>
